(function () {
  const Core = window.RB.Core;
  const { empower, buff } = window.RB.CardLib;
  const { OTHER_FRIENDLY_UNIT_OR_GEAR, EARLY_TURN, readySomethingElse, drawIfEarly } = window.RB.CardLib.ven;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Apprentice Mage": {
      triggers: [
        {
          on: "empowered",
          optional: false,
          label: "When I become [Empowered], [Predict 2]",
          targets: [],
          program: [{ op: "predict", n: 2 }],
          self: true,
        },
      ],
      abilities: [
        empower({ energy: 2, pips: 0, anyPower: 0, domains: null }),
      ],
      selfMightSpecs: [{ n: 1, cond: { k: "selfEmpowered" } }],
    },

    "Clairvoyance": { play: [{ op: "predict", n: 5 }, { op: "draw", n: 2 }] },

    "Cloud Drake": { play: [{ op: "draw", n: 1 }] },

    "Covert Informant": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move, draw 1",
          targets: [],
          program: [{ op: "draw", n: 1 }],
          self: true,
          condSpec: { k: "selfEmpowered" },
        },
      ],
      abilities: [
        empower({ energy: 3, pips: 0, anyPower: 0, domains: null }),
      ],
    },

    "Dredge Up": {
      play: [{ op: "draw", n: 1 }],
      flowCost: { energy: 2, pips: 0, anyPower: 0, domains: null },
    },

    "Iterative Design": {
      play: [{ op: "token", name: "Mech", n: 1, loc: "base", exhausted: false }],
      flowCost: { energy: 2, pips: 1, anyPower: 0, domains: ["mind"] },
    },

    "Defender of Tomorrow": {
      abilities: [
        empower({ energy: 2, pips: 0, anyPower: 2, domains: null }),
        {
          cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
          label: "Ready a gear (2 gear while Empowered)",
          exhausts: true,
          program: [
            {
              op: "choose", bind: "g1",
              spec: { type: "gear", ready: false },
              prompt: "Ready which gear?",
            },
            { op: "ready", to: "$g1" },
            {
              op: "if", cond: { k: "selfEmpowered" },
              then: [
                {
                  op: "choose", bind: "g2",
                  spec: { type: "gear", ready: false, notBind: "g1" },
                  min: 0,
                  prompt: "Empowered: ready a second gear",
                },
                { op: "ready", to: "$g2" },
              ],
            },
          ],
        },
      ],
    },

    "Acceleration Gate": {
      targets: [
        {
          bind: "t", spec: { ready: false },
          min: 0, max: 4,
          prompt: "Ready up to 4 units, gear, and/or runes",
        },
      ],
      play: [{ op: "ready", to: "$t" }],
    },

    "Soul's Reflection": {
      triggers: [
        {
          on: "empowered", label: "you empower something else: empower me",
          condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evOther" }] },
          program: [{ op: "empowerSource" }],
        },
      ],
      abilities: [
        {
          label: "Disempower me: a unit at a battlefield gets -2 Might",
          disempowerSelf: true,
          exhausts: true,
          targets: [
            {
              bind: "t", spec: { type: "unit", atBf: true },
              prompt: "Give which unit at a battlefield -2 Might this turn?",
            },
          ],
          program: [buff("$t", -2)],
        },
      ],
    },

    "Rebuttal": {
      targets: [
        {
          bind: "t", spec: { zone: "chain", type: "spell", maxEnergy: 4 },
          prompt: "Choose a spell with Energy cost 4 or less",
        },
      ],
      play: [
        {
          op: "may",
          prompt: "Pay 1 rainbow to gain control of it instead of countering it?",
          then: [
            {
              op: "payCost",
              cost: { energy: 0, pips: 0, anyPower: 1, domains: null },
              varKey: "rebuttal", skipOnFail: 2,
            },
            { op: "takeSpellControl", to: "$t", rechoose: true },
            { op: "end" },
          ],
        },
        { op: "counter", to: "$t" },
      ],
    },

    "Applied Researchers": {
      abilities: [
        empower({ energy: 3, pips: 0, anyPower: 0, domains: null }),
      ],
      auraCostMod: [
        {
          who: "friendly",
          what: { type: "spell" },
          cond: { k: "selfEmpowered" },
          energyLess: 1,
          powerLess: 1,
          min: 1,
        },
      ],
    },

    "Bottled Constellation": {
      triggers: [
        {
          on: "mainPhase",
          you: true,
          label: "kill 3 other friendly units and/or gear to score 1 point",
          targets: [],
          program: [
            {
              op: "if",
              cond: { k: "count", spec: OTHER_FRIENDLY_UNIT_OR_GEAR, n: 3 },
              then: [
                {
                  op: "may",
                  prompt: "Kill 3 other friendly units and/or gear to score 1 point?",
                  then: [
                    {
                      op: "choose",
                      bind: "k",
                      spec: OTHER_FRIENDLY_UNIT_OR_GEAR,
                      min: 3,
                      max: 3,
                      prompt: "Kill which 3 other friendly units and/or gear?",
                    },
                    { op: "kill", to: "$k", credit: false },
                    { op: "points", n: 1 },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },

    "Grumpy Rockbear": {
      abilities: [
        empower({ energy: 12, pips: 0, anyPower: 0, domains: null }),
      ],
      selfKwSpecs: [
        { name: "deflect", value: null, cond: { k: "selfEmpowered" } },
        { name: "shield", value: 3, cond: { k: "selfEmpowered" } },
      ],
      auraCostMod: [{
        ability: { self: true, label: "Empower" },
        energyLess: { count: { type: "rune", friendly: true } },
      }],
    },

    "Hextech Formula": {
      entersExhausted: true,
      abilities: [
        {
          label: "Exhaust: Empower another gear",
          exhausts: true,
          targets: [
            {
              bind: "g",
              spec: { type: "gear", other: true, attached: true },
              prompt: "Empower which other gear?",
            },
          ],
          program: [{ op: "empower", to: "$g" }],
        },
      ],
    },

    "Jayce, Brilliant Inventor": {
      play: readySomethingElse,
      triggers: [
        {
          on: "finalizedCard",
          label: "first non-token gear each turn: ready something",
          targets: [],
          condSpec: {
            k: "and",
            conds: [
              { k: "evYou" },
              { k: "evType", type: "gear" },
              { k: "turnFact", key: "gearPlayed", n: 1, cmp: "exactly" },
            ],
          },
          program: readySomethingElse,
        },
      ],
    },

    "Mel, Newly Awakened": {
      play: [{ op: "draw", n: 1 }],
      abilities: [
        empower({ energy: 3, pips: 0, anyPower: 0, domains: null }),
      ],
      auraUncounterable: { requiresEmpowered: true },
      auraMinusMightBonus: { n: 1, requiresEmpowered: true },
    },

    "Mesmerize": {
      play: [
        {
          op: "option",
          varKey: "mode",
          prompt: "Choose one",
          options: [
            "Return a friendly unit to its owner's hand",
            "Give an enemy unit -2 Might this turn",
          ],
        },
        {
          op: "if",
          cond: { k: "varEq", key: "mode", value: 0 },
          then: [
            {
              op: "choose",
              bind: "f",
              spec: { type: "unit", friendly: true },
              prompt: "Return which friendly unit to its owner's hand?",
            },
            { op: "toHand", to: "$f" },
          ],
          else: [
            {
              op: "choose",
              bind: "e",
              spec: { type: "unit", enemy: true },
              prompt: "Give which enemy unit -2 Might this turn?",
            },
            buff("$e", -2),
          ],
        },
      ],
    },

    "Otterpus": {
      restrictScore: [
        { who: "all", cond: EARLY_TURN, reason: "Otterpus: they draw 1 instead" },
      ],
      triggers: [
        {
          on: "conquer",
          label: "conquering on an early turn draws instead",
          controllerFromEvent: true,
          targets: [],
          program: drawIfEarly,
        },
        {
          on: "hold",
          label: "holding on an early turn draws instead",
          controllerFromEvent: true,
          targets: [],
          program: drawIfEarly,
        },
      ],
    },

    "Patched Porobot": {
      play: [
        {
          op: "if",
          cond: {
            k: "count",
            spec: { type: "gear", friendly: true, other: true, attached: true, ignoreUntargetable: true },
            n: 3,
          },
          then: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Plaza Guardian": {
      costMods: [{ energyLess: { count: { type: "gear", friendly: true, attached: true } } }],
    },

    "Questionable Tome": {
      abilities: [
        {
          label: "Empower",
          requiresNotEmpowered: true,
          exhausts: true,
          program: [{ op: "empowerSource" }],
        },
        {
          cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
          label: "Disempower this, 1 Energy, exhaust: Draw 1",
          disempowerSelf: true,
          exhausts: true,
          program: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Shock Blast": {
      targets: [
        {
          bind: "t",
          spec: { type: "unit", atBf: true },
          prompt: "Deal 4 to which unit at a battlefield?",
        },
      ],
      play: [{ op: "deal", to: "$t", n: 4 }],
      costMods: [{
        energyLess: 2,
        cond: {
          k: "count",
          spec: {
            orSpecs: [
              { friendly: true, empowered: true },
              { zone: "legend", friendly: true, empowered: true },
            ],
          },
        },
      }],
    },

    "Sky Cruiser": {
      abilities: [
        {
          cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
          costDiscard: 1,
          costDiscardType: "gear",
          exhausts: true,
          label: "Discard a gear, 1 Energy, exhaust: deal 4 to a unit at a battlefield",
          targets: [
            {
              bind: "t",
              spec: { type: "unit", atBf: true },
              prompt: "Deal 4 to which unit at a battlefield?",
            },
          ],
          program: [{ op: "deal", to: "$t", n: 4 }],
        },
      ],
    },

    "Decree of Insight": {
      ignoreDeflect: true,
      targets: [{
        bind: "t", spec: { type: "unit", enemy: true, domain: "body" },
        prompt: "Give which enemy Body unit -5 Might?",
      }],
      play: [buff("$t", -5)],
    },

    "Nasus, Guardian of Knowledge": {
      triggers: [{
        on: "dies", oncePerTurn: true,
        label: "an enemy unit here dies: channel 1 rune exhausted",
        condSpec: {
          k: "and",
          conds: [
            { k: "evSnapshotEnemy" },
            { k: "evSnapshotUnit" },
            { k: "evSnapshotSelfLoc" },
            { k: "selfAtBf" },
          ],
        },
        program: [{ op: "channel", n: 1, exhausted: true }],
      }],
    },

    "Swain, Visionary": {
      triggers: [{
        on: "unitConquer", self: true,
        label: "conquered after a unit, a gear and a spell: score 1",
        condSpec: {
          k: "and",
          conds: [
            { k: "turnFact", key: "nonTokenUnitsPlayed", n: 1 },
            { k: "turnFact", key: "gearPlayed", n: 1 },
            { k: "turnFact", key: "spells", n: 1 },
          ],
        },
        program: [{ op: "points", n: 1 }],
      }],
    },

    "Temporal Breach": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Banish and replay which unit?" }],
      play: [
        { op: "setVarLoc", varKey: "tb", from: "$t" },
        { op: "banish", to: "$t" },
        { op: "playFrom", to: "$t", waive: "all", byOwner: true, locVar: "tb" },
      ],
    },
  });
})();
